import React, { useEffect, useState } from "react";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import CustomButton from "components/common/Enhansment/Button/CustomButton";
import DateRangeWithRegister from "components/common/DateRangePicker/DateRangePickerWithRegister";
import { apiPostRequest, apiPutRequest } from "helpers/Requests";
import { toast } from "react-toastify";
import { getUrlRole } from "Utils/utils";

const SetEmployeeExpiryModal = (props) => {
  const {
    open,
    setOpen,
    isUserGracePeriodOver,
    handleClose,
    uuid,
    refreshFormList,
    participantId,
    currentExpiryDate,
  } = props;
  const [loading, setLoading] = useState(false);

  const [expiryDate, setExpiryDate] = useState("");
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

  useEffect(() => {
    if (open && currentExpiryDate) {
      try {
        const parsedDate = new Date(currentExpiryDate);
        if (!isNaN(parsedDate.getTime())) {
          // Format as YYYY-MM-DD for input
          const year = parsedDate.getFullYear();
          const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
          const day = String(parsedDate.getDate()).padStart(2, "0");
          setExpiryDate(`${year}-${month}-${day}`);
        } else {
          setExpiryDate("");
        }
      } catch (error) {
        console.error("Error parsing currentExpiryDate:", error);
        setExpiryDate("");
      }
    } else if (open) {
      setExpiryDate("");
    }
  }, [open, currentExpiryDate]);


  const handleSave = async () => {
    try {
      setLoading(true);

      if (!expiryDate) {
        toast.error("Please select a valid expiry date.");
        return;
      }

      const payload = {
        form_id: uuid,
        expiry_date: expiryDate, // send as YYYY-MM-DD
      };

      const response = await apiPutRequest(`worker/hrm/update-expiry`, payload);

      if (response?.status === 200 || response?.status === 201) {
        toast.success("Expiry date updated successfully!");
        refreshFormList(); // Refetch forms list
        setOpen(false);
      } else {
        toast.error(response?.data?.message || "Failed to update expiry date.");
      }
    } catch (error) {
      console.error("Update expiry error:", error);
      toast.error(
        error?.response?.data?.message ||
          "Something went wrong while updating expiry date."
      );
    } finally {
      setLoading(false);
    }
  };

  const modalFooter = () => (
    <>
      <CustomButton
        showLoading={request.isRequested}
        isDisabled={request.isRequested || isUserGracePeriodOver}
        label='Yes, set Expiry Date'
        clickHandler={handleSave}
      />
      <CustomButton
        label='No, cancel changes'
        clickHandler={handleClose}
        variant='danger'
      />
    </>
  );

  return (
    <ModalSkeleton
      modalFooter={modalFooter()}
      isOpen={open}
      closeModal={() => setOpen(false)}
      cssClass='w-[35%]'
      title='Set Expiry Date'
    >
      <div className='p-4 space-y-4'>
        <input
          type='text'
          style={{
            position: "absolute",
            opacity: 0,
            height: 0,
            width: 0,
            pointerEvents: "none",
          }}
          autoFocus
        />

        <label className='block text-sm font-medium text-gray-700'>
          Select an Expiry date for completed form:
        </label>

        <DateRangeWithRegister
          isSingleDate
          placeholder='Select Expiry Date'
          showCalendarIcon
          field={{
            value: expiryDate,
            onChange: (date) => {
              setExpiryDate(date);
            },
          }}
          fieldState={{
            error: expiryDate ? null : { message: "Please select a date" },
          }}
        />
      </div>
    </ModalSkeleton>
  );
};

export default SetEmployeeExpiryModal;
